import ContentConfig from '../config/ContentConfig';
import getUrlPrefix from './getUrlPrefix';
import logger from '../log';

const log = logger.getLogger(__filename);

export interface NodeInfoData {
  activeClusterId?: string;
  agentId?: string;
  nodeId?: string;
}
export type OptionalNodeInfoData = NodeInfoData | void;

export interface NodeInfoRequestData {
  config: ContentConfig;
  contentId: string;
  controller: AbortController;
  tenantId: string;
}

export interface AgentNodeData {
  attachment: {
    activeCluster: {
      id: string;
    };
  };
  agentId: string;
  contentId: string;
  id: string;
  tenantId: string;
}

const getNodeInfo = (
  data: NodeInfoRequestData
): Promise<OptionalNodeInfoData> => {
  const { config, contentId, controller, tenantId } = data;
  if (config.agent.disabled || !config.agent.port) {
    return Promise.resolve(undefined);
  }
  const baseUrl = `${getUrlPrefix(config)}:${config.agent.port}/node`;
  const url = new URL(baseUrl);
  url.searchParams.set('tenantId', tenantId);
  url.searchParams.set('contentId', contentId);
  const options = { signal: controller.signal };
  return fetch(url.toString(), options)
    .then(async (res: Response) => {
      const responseData = await res.json();
      const nodes: AgentNodeData[] = responseData.nodes;
      if (!nodes) {
        return;
      }
      const node = nodes.find(value => {
        return value.tenantId === tenantId && value.contentId === contentId;
      });
      if (!node) {
        log.info('No node found for', { tenantId, contentId, nodes });
        return;
      }
      const activeClusterId =
        node &&
        node.attachment &&
        node.attachment.activeCluster &&
        node.attachment.activeCluster.id;
      return {
        nodeId: node && node.id,
        agentId: node && node.agentId,
        activeClusterId
      };
    })
    .catch(e => {
      log.info('Failed to get agent information', e);
      return;
    });
};
export default getNodeInfo;
